import { Button } from "@/view/components/ui/button";
import { DialogClose, DialogContent } from "@/view/components/ui/dialog";
import { TickCircle } from "iconsax-react";
import useProposalSuccessModal from "./useProposalSuccessModal";
import { ProposalData } from "..";

interface ProposalSuccessModalProps {
  proposalData: ProposalData;
}

export default function ProposalSuccessModal({
  proposalData,
}: ProposalSuccessModalProps) {
  const { isLoading, copyWhatsAppLink } = useProposalSuccessModal({
    proposalData,
  });

  return (
    <DialogContent className="h-[320px] overflow-y-auto p-6 sm:max-w-2xl">
      <div className="mt-10 flex flex-col items-start gap-1.5 px-6">
        <TickCircle variant="Bold" size={40} className="text-success" />
        <strong className="font-semibold">Proposta realizada</strong>
        <p className="text-sm font-medium text-black04">
          A proposta está em andamento. Compartilhe o link com o cliente para
          continuar. Você será notificado quando ele finalizar.
        </p>
      </div>
      <div className="mt-6 flex justify-end gap-2">
        <Button
          variant="outline"
          className="w-[180px] rounded-full text-primary"
          onClick={copyWhatsAppLink}
          disabled={isLoading}
        >
          Copiar link
        </Button>
        <DialogClose asChild>
          <Button className="w-[180px] rounded-full font-semibold text-white">
            Voltar para o início
          </Button>
        </DialogClose>
      </div>
    </DialogContent>
  );
}
